import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import PasswordView from '../views/PasswordView.vue'
import { checkLogin } from '../auth'
import GameView from '../views/GameView.vue'
import BackupView from '../views/BackupView.vue'
import AiView from '../views/AiView.vue'
import ServerSettingsView from '../views/ServerSettingsView.vue'
import ModsView from '../views/ModsView.vue'
import SavesView from '../views/SavesView.vue'
import PlayersView from '../views/PlayersView.vue'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { path: '/', name: 'home', component: HomeView },
    { path: '/game', name: 'game', component: GameView },
    { path: '/backups', name: 'backups', component: BackupView },
    { path: '/companion', name: 'companion', component: AiView },
    { path: '/settings', name: 'settings', component: ServerSettingsView },
    { path: '/mods', name: 'mods', component: ModsView },
    { path: '/saves', name: 'saves', component: SavesView },
    { path: '/players', name: 'players', component: PlayersView },
    { path: '/login', name: 'login', component: LoginView },
    { path: '/account/password', name: 'password', component: PasswordView },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
})

router.beforeEach(async (to) => {
  const user = await checkLogin()
  if (!user) return to.name === 'login' ? true : { name: 'login' }
  if (user.mustChangePassword && to.name !== 'password') return { name: 'password' }
  if (to.name === 'login') return { name: 'home' }
  return true
})

export default router
